module.exports = __webpack_public_path__ + "img/logo22.14d3f8c6.png";